function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/*
 * @copyright Copyright (c) 2020 Florian Steffens
 *
 * @author Florian Steffens <flost-online@mailbox.org>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
import Vue from 'vue';
import Vuex from 'vuex';
import { WeightApi } from './WeightApi';
import { PersonApi } from './PersonApi';
import { MeasurementApi } from './MeasurementApi';
import { FeelingApi } from './FeelingApi';
import { SleepApi } from './SleepApi';
import { SmokingApi } from './SmokingApi';
import { ActivitiesApi } from './ActivitiesApi';
import { showSuccess } from '@nextcloud/dialogs';
Vue.use(Vuex);
var weightApiClient = new WeightApi();
var personApiClient = new PersonApi();
var measurementApiClient = new MeasurementApi();
var feelingApiClient = new FeelingApi();
var sleepApiClient = new SleepApi();
var smokingApiClient = new SmokingApi();
var activitiesApiClient = new ActivitiesApi();
export default new Vuex.Store({
  state: {
    initialLoading: true,
    loading: false,
    app: 'health',
    activePersonId: null,
    activeModule: 'person',
    // person
    showSidebar: false,
    persons: null,
    rWeightDatasets: [],
    measurementDatasets: [],
    feelingDatasets: [],
    sleepDatasets: [],
    smokingDatasets: [],
    activitiesDatasets: []
  },
  getters: {
    person: function person(state) {
      return state.persons && state.persons[state.activePersonId] ? state.persons[state.activePersonId] : null;
    },
    personsLength: function personsLength(state) {
      return state.persons ? state.persons.length : 0;
    }
  },
  mutations: {
    persons: function persons(state, _persons) {
      state.persons = _persons.slice();
    },
    personsAdd: function personsAdd(state, person) {
      state.persons.push(person);
    },
    personsDelete: function personsDelete(state, person) {
      var existingIndex = state.persons.findIndex(function (set) {
        return set.id === person.id;
      });

      if (existingIndex !== -1) {
        state.persons.splice(existingIndex, 1);
      }
    },
    personUpdate: function personUpdate(state, data) {
      var p = state.persons;
      var existingIndex = p.findIndex(function (set) {
        return set.id === data.id;
      });

      if (existingIndex !== -1) {
        p.splice(existingIndex, 1);
        p.push(data);
      }

      state.persons = p;
    },
    activePersonId: function activePersonId(state, id) {
      state.activePersonId = id;
    },
    activeModule: function activeModule(state, module) {
      state.activeModule = module;
    },
    personData: function personData(state, data) {
      state.personData = data;
    },
    // directly called (without actions)
    showSidebar: function showSidebar(state, bool) {
      state.showSidebar = bool;
    },
    rWeightDatasets: function rWeightDatasets(state, data) {
      state.rWeightDatasets = data;
    },
    rWeightDatasetsAppend: function rWeightDatasetsAppend(state, data) {
      state.rWeightDatasets.push(data);
    },
    rWeightDatasetsDelete: function rWeightDatasetsDelete(state, data) {
      var existingIndex = state.rWeightDatasets.findIndex(function (set) {
        return set.id === data.id;
      });

      if (existingIndex !== -1) {
        state.rWeightDatasets.splice(existingIndex, 1);
      }
    },
    rWeightDatasetsUpdate: function rWeightDatasetsUpdate(state, data) {
      var datasets = state.rWeightDatasets;
      var existingIndex = datasets.findIndex(function (set) {
        return set.id === data.id;
      });

      if (existingIndex !== -1) {
        datasets.splice(existingIndex, 1);
        datasets.push(data);
      }

      state.rWeightDatasets = datasets;
    },
    loading: function loading(state, status) {
      state.loading = !!status;
    },
    initialLoading: function initialLoading(state, status) {
      state.initialLoading = !!status;
    },
    // -------------
    measurementDatasets: function measurementDatasets(state, data) {
      state.measurementDatasets = data;
    },
    measurementDatasetsAppend: function measurementDatasetsAppend(state, data) {
      state.measurementDatasets.push(data);
    },
    measurementDatasetsDelete: function measurementDatasetsDelete(state, data) {
      var existingIndex = state.measurementDatasets.findIndex(function (set) {
        return set.id === data.id;
      });

      if (existingIndex !== -1) {
        state.measurementDatasets.splice(existingIndex, 1);
      }
    },
    measurementDatasetsUpdate: function measurementDatasetsUpdate(state, data) {
      var datasets = state.measurementDatasets;
      var existingIndex = datasets.findIndex(function (set) {
        return set.id === data.id;
      });

      if (existingIndex !== -1) {
        datasets.splice(existingIndex, 1);
        datasets.push(data);
      }

      state.measurementDatasets = datasets;
    },
    // -------------
    feelingDatasets: function feelingDatasets(state, data) {
      state.feelingDatasets = data;
    },
    feelingDatasetsAppend: function feelingDatasetsAppend(state, data) {
      state.feelingDatasets.push(data);
    },
    feelingDatasetsDelete: function feelingDatasetsDelete(state, data) {
      var existingIndex = state.feelingDatasets.findIndex(function (set) {
        return set.id === data.id;
      });

      if (existingIndex !== -1) {
        state.feelingDatasets.splice(existingIndex, 1);
      }
    },
    feelingDatasetsUpdate: function feelingDatasetsUpdate(state, data) {
      var datasets = state.feelingDatasets;
      var existingIndex = datasets.findIndex(function (set) {
        return set.id === data.id;
      });

      if (existingIndex !== -1) {
        datasets.splice(existingIndex, 1);
        datasets.push(data);
      }

      state.feelingDatasets = datasets;
    },
    // -------------
    sleepDatasets: function sleepDatasets(state, data) {
      state.sleepDatasets = data;
    },
    sleepDatasetsAppend: function sleepDatasetsAppend(state, data) {
      state.sleepDatasets.push(data);
    },
    sleepDatasetsDelete: function sleepDatasetsDelete(state, data) {
      var existingIndex = state.sleepDatasets.findIndex(function (set) {
        return set.id === data.id;
      });

      if (existingIndex !== -1) {
        state.sleepDatasets.splice(existingIndex, 1);
      }
    },
    sleepDatasetsUpdate: function sleepDatasetsUpdate(state, data) {
      var datasets = state.sleepDatasets;
      var existingIndex = datasets.findIndex(function (set) {
        return set.id === data.id;
      });

      if (existingIndex !== -1) {
        datasets.splice(existingIndex, 1);
        datasets.push(data);
      }

      state.sleepDatasets = datasets;
    },
    // -------------
    smokingDatasets: function smokingDatasets(state, data) {
      state.smokingDatasets = data;
    },
    smokingDatasetsAppend: function smokingDatasetsAppend(state, data) {
      state.smokingDatasets.push(data);
    },
    smokingDatasetsDelete: function smokingDatasetsDelete(state, data) {
      var existingIndex = state.smokingDatasets.findIndex(function (set) {
        return set.id === data.id;
      });

      if (existingIndex !== -1) {
        state.smokingDatasets.splice(existingIndex, 1);
      }
    },
    smokingDatasetsUpdate: function smokingDatasetsUpdate(state, data) {
      var datasets = state.smokingDatasets;
      var existingIndex = datasets.findIndex(function (set) {
        return set.id === data.id;
      });

      if (existingIndex !== -1) {
        datasets.splice(existingIndex, 1);
        datasets.push(data);
      }

      state.smokingDatasets = datasets;
    },
    // -------------
    activitiesDatasets: function activitiesDatasets(state, data) {
      state.activitiesDatasets = data;
    },
    activitiesDatasetsAppend: function activitiesDatasetsAppend(state, data) {
      state.activitiesDatasets.push(data);
    },
    activitiesDatasetsDelete: function activitiesDatasetsDelete(state, data) {
      var existingIndex = state.activitiesDatasets.findIndex(function (set) {
        return set.id === data.id;
      });

      if (existingIndex !== -1) {
        state.activitiesDatasets.splice(existingIndex, 1);
      }
    },
    activitiesDatasetsUpdate: function activitiesDatasetsUpdate(state, data) {
      var datasets = state.activitiesDatasets;
      var existingIndex = datasets.findIndex(function (set) {
        return set.id === data.id;
      });

      if (existingIndex !== -1) {
        datasets.splice(existingIndex, 1);
        datasets.push(data);
      }

      state.activitiesDatasets = datasets;
    }
  },
  actions: {
    loadPersons: function loadPersons(_ref) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var dispatch, state, commit, persons;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch = _ref.dispatch, state = _ref.state, commit = _ref.commit;
                commit('initialLoading', true);
                _context.next = 4;
                return personApiClient.load();

              case 4:
                persons = _context.sent;

                if (persons && persons.length > 0) {
                  commit('persons', persons);

                  if (state.activePersonId === null) {
                    dispatch('setActivePerson', 0);
                  }

                  dispatch('loadModuleContentForPerson');
                }

                commit('initialLoading', false);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    setActivePerson: function setActivePerson(_ref2, id) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit;
      commit('activePersonId', id); // commit('setModuleSettings', {})

      dispatch('loadModuleContentForPerson');
    },
    setActiveModule: function setActiveModule(_ref3, module) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit;
      commit('activeModule', module);
      dispatch('loadModuleContentForPerson');
    },
    loadModuleContentForPerson: function loadModuleContentForPerson(_ref4) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var getters, commit, dispatch, state;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getters = _ref4.getters, commit = _ref4.commit, dispatch = _ref4.dispatch, state = _ref4.state;
                // this ist called if the active person or module changed
                // it should load all data, that is necessary for the active module
                commit('loading', true); // await dispatch('weightDatasetsLoadByPerson', [])
                // await dispatch('measurementDatasetsLoadByPerson', [])
                // await dispatch('feelingDatasetsLoadByPerson', [])

                commit('rWeightDatasets', []);
                commit('feelingDatasets', []);
                commit('sleepDatasets', []);
                commit('measurementDatasets', []);
                commit('smokingDatasets', []);
                commit('activitiesDatasets', []);

                if (!(state.activeModule === 'weight')) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 11;
                return dispatch('weightDatasetsLoadByPerson', getters.person.id);

              case 11:
                _context2.next = 36;
                break;

              case 13:
                if (!(state.activeModule === 'measurement')) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 16;
                return dispatch('measurementDatasetsLoadByPerson', getters.person.id);

              case 16:
                _context2.next = 36;
                break;

              case 18:
                if (!(state.activeModule === 'feeling')) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 21;
                return dispatch('feelingDatasetsLoadByPerson', getters.person.id);

              case 21:
                _context2.next = 36;
                break;

              case 23:
                if (!(state.activeModule === 'sleep')) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 26;
                return dispatch('sleepDatasetsLoadByPerson', getters.person.id);

              case 26:
                _context2.next = 36;
                break;

              case 28:
                if (!(state.activeModule === 'smoking')) {
                  _context2.next = 33;
                  break;
                }

                _context2.next = 31;
                return dispatch('smokingDatasetsLoadByPerson', getters.person.id);

              case 31:
                _context2.next = 36;
                break;

              case 33:
                if (!(state.activeModule === 'activities')) {
                  _context2.next = 36;
                  break;
                }

                _context2.next = 36;
                return dispatch('activitiesDatasetsLoadByPerson', getters.person.id);

              case 36:
                commit('loading', false);

              case 37:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    setValue: function setValue(_ref5, data) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var commit, state, getters, id, o;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit = _ref5.commit, state = _ref5.state, getters = _ref5.getters;
                // console.debug('try to update person value', data)
                // data: {key, value, [id]}
                id = 'id' in data ? data.id : getters.person.id;
                _context3.next = 4;
                return personApiClient.updateValue(id, data.key, data.value);

              case 4:
                o = _context3.sent;
                // console.debug('return from person api', o)
                commit('personUpdate', o);
                showSuccess(t('health', 'Value successfully saved', {}));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    addPerson: function addPerson(_ref6, name) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var state, dispatch, commit, p;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = _ref6.state, dispatch = _ref6.dispatch, commit = _ref6.commit;
                _context4.next = 3;
                return personApiClient.addPerson(name);

              case 3:
                p = _context4.sent;
                commit('personsAdd', p);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    deletePerson: function deletePerson(_ref7, person) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var state, dispatch, commit, existingIndex;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                state = _ref7.state, dispatch = _ref7.dispatch, commit = _ref7.commit;
                existingIndex = state.persons.findIndex(function (set) {
                  return set.id === person.id;
                });
                _context5.next = 4;
                return personApiClient.deletePerson(person.id);

              case 4:
                commit('personsDelete', person);

                if (existingIndex !== -1) {
                  dispatch('setActivePerson', 0);
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // module weight
    weightDatasetsLoadByPerson: function weightDatasetsLoadByPerson(_ref8, personId) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var commit, datasets;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                commit = _ref8.commit;
                _context6.next = 3;
                return weightApiClient.findDatasetsByPerson(personId);

              case 3:
                datasets = _context6.sent;
                // console.debug('found datasets', datasets)
                commit('rWeightDatasets', datasets); // console.debug('saved to store "rWeightDatasets"')

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    rWeightDatasetsAppend: function rWeightDatasetsAppend(_ref9, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                commit = _ref9.commit, getters = _ref9.getters;
                _context7.next = 3;
                return weightApiClient.addSet(getters.person.id, set);

              case 3:
                o = _context7.sent;
                // console.debug('returned o', o)
                commit('rWeightDatasetsAppend', o);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    rWeightDatasetsUpdate: function rWeightDatasetsUpdate(_ref10, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                commit = _ref10.commit, getters = _ref10.getters;
                console.debug('update weight dataset', set);
                _context8.next = 4;
                return weightApiClient.updateSet(set);

              case 4:
                o = _context8.sent;
                console.debug('returned o', o);
                commit('rWeightDatasetsUpdate', o);

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    rWeightDatasetsDelete: function rWeightDatasetsDelete(_ref11, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                commit = _ref11.commit, getters = _ref11.getters;
                _context9.next = 3;
                return weightApiClient.deleteSet(set);

              case 3:
                o = _context9.sent;
                // console.debug('returned o', o)
                commit('rWeightDatasetsDelete', o);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    // module measurement
    measurementDatasetsLoadByPerson: function measurementDatasetsLoadByPerson(_ref12, personId) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var commit, datasets;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                commit = _ref12.commit;
                _context10.next = 3;
                return measurementApiClient.findDatasetsByPerson(personId);

              case 3:
                datasets = _context10.sent;
                // console.debug('found datasets', datasets)
                commit('measurementDatasets', datasets);

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    measurementDatasetsAppend: function measurementDatasetsAppend(_ref13, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                commit = _ref13.commit, getters = _ref13.getters;
                _context11.next = 3;
                return measurementApiClient.addSet(getters.person.id, set);

              case 3:
                o = _context11.sent;
                // console.debug('returned o', o)
                commit('measurementDatasetsAppend', o);

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    measurementDatasetsUpdate: function measurementDatasetsUpdate(_ref14, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                commit = _ref14.commit, getters = _ref14.getters;
                _context12.next = 3;
                return measurementApiClient.updateSet(set);

              case 3:
                o = _context12.sent;
                // console.debug('returned o', o)
                commit('measurementDatasetsUpdate', o);

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    measurementDatasetsDelete: function measurementDatasetsDelete(_ref15, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                commit = _ref15.commit, getters = _ref15.getters;
                _context13.next = 3;
                return measurementApiClient.deleteSet(set);

              case 3:
                o = _context13.sent;
                // console.debug('returned o', o)
                commit('measurementDatasetsDelete', o);

              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },
    // module feeling
    feelingDatasetsLoadByPerson: function feelingDatasetsLoadByPerson(_ref16, personId) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var commit, datasets;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                commit = _ref16.commit;
                _context14.next = 3;
                return feelingApiClient.findDatasetsByPerson(personId);

              case 3:
                datasets = _context14.sent;
                // console.debug('found datasets', datasets)
                commit('feelingDatasets', datasets);

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }))();
    },
    feelingDatasetsAppend: function feelingDatasetsAppend(_ref17, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                commit = _ref17.commit, getters = _ref17.getters;
                _context15.next = 3;
                return feelingApiClient.addSet(getters.person.id, set);

              case 3:
                o = _context15.sent;
                // console.debug('returned o', o)
                commit('feelingDatasetsAppend', o);

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }))();
    },
    feelingDatasetsUpdate: function feelingDatasetsUpdate(_ref18, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                commit = _ref18.commit, getters = _ref18.getters;
                _context16.next = 3;
                return feelingApiClient.updateSet(set);

              case 3:
                o = _context16.sent;
                // console.debug('returned o', o)
                commit('feelingDatasetsUpdate', o);

              case 5:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }))();
    },
    feelingDatasetsDelete: function feelingDatasetsDelete(_ref19, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                commit = _ref19.commit, getters = _ref19.getters;
                _context17.next = 3;
                return feelingApiClient.deleteSet(set);

              case 3:
                o = _context17.sent;
                // console.debug('returned o', o)
                commit('feelingDatasetsDelete', o);

              case 5:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }))();
    },
    // module sleep
    sleepDatasetsLoadByPerson: function sleepDatasetsLoadByPerson(_ref20, personId) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var commit, datasets;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                commit = _ref20.commit;
                _context18.next = 3;
                return sleepApiClient.findDatasetsByPerson(personId);

              case 3:
                datasets = _context18.sent;
                // console.debug('found datasets', datasets)
                commit('sleepDatasets', datasets);

              case 5:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }))();
    },
    sleepDatasetsAppend: function sleepDatasetsAppend(_ref21, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                commit = _ref21.commit, getters = _ref21.getters;
                _context19.next = 3;
                return sleepApiClient.addSet(getters.person.id, set);

              case 3:
                o = _context19.sent;
                // console.debug('returned o', o)
                commit('sleepDatasetsAppend', o);

              case 5:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }))();
    },
    sleepDatasetsUpdate: function sleepDatasetsUpdate(_ref22, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                commit = _ref22.commit, getters = _ref22.getters;
                _context20.next = 3;
                return sleepApiClient.updateSet(set);

              case 3:
                o = _context20.sent;
                // console.debug('returned o', o)
                commit('sleepDatasetsUpdate', o);

              case 5:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }))();
    },
    sleepDatasetsDelete: function sleepDatasetsDelete(_ref23, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                commit = _ref23.commit, getters = _ref23.getters;
                _context21.next = 3;
                return sleepApiClient.deleteSet(set);

              case 3:
                o = _context21.sent;
                // console.debug('returned o', o)
                commit('sleepDatasetsDelete', o);

              case 5:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }))();
    },
    // module smoking
    smokingDatasetsLoadByPerson: function smokingDatasetsLoadByPerson(_ref24, personId) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var commit, datasets;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                commit = _ref24.commit;
                _context22.next = 3;
                return smokingApiClient.findDatasetsByPerson(personId);

              case 3:
                datasets = _context22.sent;
                // console.debug('found datasets', datasets)
                commit('smokingDatasets', datasets);

              case 5:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }))();
    },
    smokingDatasetsAppend: function smokingDatasetsAppend(_ref25, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                commit = _ref25.commit, getters = _ref25.getters;
                _context23.next = 3;
                return smokingApiClient.addSet(getters.person.id, set);

              case 3:
                o = _context23.sent;
                // console.debug('returned o', o)
                commit('smokingDatasetsAppend', o);

              case 5:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }))();
    },
    smokingDatasetsUpdate: function smokingDatasetsUpdate(_ref26, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                commit = _ref26.commit, getters = _ref26.getters;
                _context24.next = 3;
                return smokingApiClient.updateSet(set);

              case 3:
                o = _context24.sent;
                // console.debug('returned o', o)
                commit('smokingDatasetsUpdate', o);

              case 5:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }))();
    },
    smokingDatasetsDelete: function smokingDatasetsDelete(_ref27, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                commit = _ref27.commit, getters = _ref27.getters;
                _context25.next = 3;
                return smokingApiClient.deleteSet(set);

              case 3:
                o = _context25.sent;
                // console.debug('returned o', o)
                commit('smokingDatasetsDelete', o);

              case 5:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }))();
    },
    // module activities
    activitiesDatasetsLoadByPerson: function activitiesDatasetsLoadByPerson(_ref28, personId) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var commit, datasets;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                commit = _ref28.commit;
                _context26.next = 3;
                return activitiesApiClient.findDatasetsByPerson(personId);

              case 3:
                datasets = _context26.sent;
                // console.debug('found datasets', datasets)
                commit('activitiesDatasets', datasets);

              case 5:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26);
      }))();
    },
    activitiesDatasetsAppend: function activitiesDatasetsAppend(_ref29, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                commit = _ref29.commit, getters = _ref29.getters;
                _context27.next = 3;
                return activitiesApiClient.addSet(getters.person.id, set);

              case 3:
                o = _context27.sent;
                // console.debug('returned o', o)
                commit('activitiesDatasetsAppend', o);

              case 5:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }))();
    },
    activitiesDatasetsUpdate: function activitiesDatasetsUpdate(_ref30, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                commit = _ref30.commit, getters = _ref30.getters;
                _context28.next = 3;
                return activitiesApiClient.updateSet(set);

              case 3:
                o = _context28.sent;
                // console.debug('returned o', o)
                commit('activitiesDatasetsUpdate', o);

              case 5:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28);
      }))();
    },
    activitiesDatasetsDelete: function activitiesDatasetsDelete(_ref31, set) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
        var commit, getters, o;
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                commit = _ref31.commit, getters = _ref31.getters;
                _context29.next = 3;
                return activitiesApiClient.deleteSet(set);

              case 3:
                o = _context29.sent;
                // console.debug('returned o', o)
                commit('activitiesDatasetsDelete', o);

              case 5:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }))();
    }
  }
});